<template>
  <span class="highlight-hook">
    <span class="highlight-label">{{ label }}</span>
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: "HighlightHook",
  components: {},
  props: {
    label: String
  }
};
</script>
<style scoped>
.highlight-hook {
  line-height: 25px;
  position: relative;
}

.highlight .highlight-label {
  --width: 214px;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.3px;
  position: absolute;
  top: 0;
  bottom: 0;
  display: inline-block;
  width: var(--width);
  margin-left: calc(var(--width) * -1);
  font-family: "Urby-Regular", Arial, Helvetica, sans-serif;
  mix-blend-mode: normal;
  transition: var(--TRANSITION);
  pointer-events: none;
}

.highlight.active .highlight-label {
  opacity: 1;
  transform: translateY(0);
}

@media only screen and (max-width: 576px) {
  .highlight .highlight-label {
    display: none;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .highlight .highlight-label {
    display: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .highlight .highlight-label {
    --width: 184px;
  }
} /*
@media only screen and (min-width: 992px) {
}*/
.highlight .highlight-label:after {
  content: " ";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1.5px;
  height: 1.5px;
  background-color: var(--BLACK);
}

@media only screen and (max-width: 576px) {
  .highlight .highlight-label {
    position: fixed;
    display: block;
    top: 0;
    bottom: auto;
    left: 0;
    right: 0;
    width: 100vw;
    /* bottom: calc(var(--LINE-HEIGHT) * 4); */
    padding-left: 25px;
    background-color: var(--WHITE);
    line-height: calc(var(--LINE-HEIGHT) * 2);
    z-index: 4000;
    margin-left: 0;
    opacity: 0;
    border-top: 1px solid var(--BLACK);
    transform: translateY(calc(var(--LINE-HEIGHT) * -2));
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .highlight .highlight-label {
    position: fixed;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    bottom: auto;
    padding-left: 25px;
    background-color: var(--WHITE);
    line-height: calc(var(--LINE-HEIGHT) * 2);
    z-index: 4000;
    margin-left: 0;
    opacity: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
}
@media only screen and (min-width: 992px) {
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/HighlightHook.vue